module.exports = __webpack_public_path__ + "img/drayage-overweigth.4e9f0d63.png";